module.exports = __webpack_public_path__ + "img/edicion.c6a874d9.png";